import React, { useState } from "react"
import { NavLink } from "react-router-dom"
import withBreadcrumbs from "react-router-breadcrumbs-hoc"
import Breadcrumb from "react-bootstrap/Breadcrumb"

import AppContext from "../../../components/AppContext"

import routes from "./Routes"
import { GetApi } from "../../../api/api"
import useQuery from "../../../features/FeatureCatalogViewer/Components/UseQuery"

interface BreadCrumbsProps {
  breadcrumbs: React.ReactNode[]
}

const BreadCrumbs = (props: BreadCrumbsProps) => {
  const [catalogDisplayText, setCatalogDisplayText] = useState("")
  const [typeDisplayText, setTypeDisplayText] = useState("")
  const setPanelContent = React.useContext(AppContext).setPanelContent
  const language = useQuery().get("language")

  const resetPanel = () => setPanelContent(undefined)

  const arrayItem = (url: string, breadcrumb: string, isLast: boolean = false) =>
    isLast ? (
      <Breadcrumb.Item key={url} active={isLast}>
        {breadcrumb}
      </Breadcrumb.Item>
    ) : (
      <li className="breadcrumb-item" key={url}>
        <NavLink to={url} onClick={resetPanel}>
          {breadcrumb}
        </NavLink>
      </li>
    )

  const getCorrectBreadcrumbText = (match: any, breadcrumb: any) => {
    if (match.path === "/featurecatalogdetails/:catalog") {
      getCatalogName(match.params.catalog)
      return catalogDisplayText
    }
    if (match.path === "/featurecatalogdetails/:catalog/:type/:pid") {
      getTypeName(match.params.catalog, match.params.type, match.params.pid)
      return typeDisplayText
    }
    return breadcrumb
  }

  const getCatalogName = async (id: string) => {
    GetApi().then(async (api) => {
      await api.getAnyFeatureCatalogInfo(id).then(async (response) => {
        setCatalogDisplayText(response.displayText!)
      })
    })
  }

  const getTypeName = async (catalogId: string, type: string, id: string) => {
    if (type === "featureTypeGroup") {
      GetApi().then(async (api) => {
        await api.getAnyFeatureTypeGroup(catalogId, parseInt(id, 10), language).then(async (response) => {
          setTypeDisplayText(response.name + " " + id)
        })
      })
    }
    if (type === "featureType") {
      GetApi().then(async (api) => {
        await api.getAnyFeatureType(catalogId, parseInt(id, 10), false, language).then(async (response) => {
          setTypeDisplayText(response.name + " " + id)
        })
      })
    }
    if (type === "attributeType") {
      GetApi().then(async (api) => {
        await api.getAnyAttributeType(catalogId, parseInt(id, 10), language).then(async (response) => {
          setTypeDisplayText(response.name + " " + id)
        })
      })
    }
  }

  // To make sure the language is kept when user clicks in bread crumb
  const qParams = language ? "?language=" + language : ""

  return (
    <Breadcrumb className="mt-3" style={{ backgroundColor: "unset" }}>
      {props.breadcrumbs.map(({ match, breadcrumb, location }: any, i: number) =>
        // Substitute actual feature catalog name for the default breadcrumb defined in Routes.tsx
        arrayItem(match.url + qParams, getCorrectBreadcrumbText(match, breadcrumb), props.breadcrumbs.length === i + 1)
      )}
    </Breadcrumb>
  )
}

// Adds a lower level path to be able to reflect it in breadcrumbs
export default withBreadcrumbs(
  new Array<any>(routes, { path: "/featurecatalogdetails/:catalog/:type/:pid", breadcrumb: "[Type]" }),
  { disableDefaults: true }
)(BreadCrumbs)
